import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";

const IMG = "https://images.pexels.com/photos/10871585/pexels-photo-10871585.jpeg?auto=compress&cs=tinysrgb&w=1200";
const POINTS = ["Pre-dispatch inspection on every unit", "Certified technicians for emergency support", "Clear servicing and fuel records", "Annual maintenance contracts that hold"];

export const Maintenance = () => (
  <section id="maintenance" className="split">
    <motion.div className="split-media" initial={{ opacity: 0, x: -40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}>
      <img src={IMG} alt="Technicians servicing an electrical panel" loading="lazy" />
      <div className="split-badge"><strong>BUILT TO LAST</strong><span>Every set. Every time.</span></div>
    </motion.div>
    <motion.div className="split-copy" initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}>
      <p className="eyebrow">MAINTENANCE THAT MATTERS</p>
      <h2 className="sec-title">Uptime is not<br />an <em>option.</em></h2>
      <p>Our team checks every set before dispatch and stays close throughout the hire. Planned servicing, rapid response — your generator is one less thing to worry about.</p>
      <ul className="check-list">
        {POINTS.map((p) => <li key={p}><Check size={15} /> {p}</li>)}
      </ul>
      <a data-testid="maintenance-book-button" className="btn btn-amber" href="#booking">Talk to a technician <ArrowUpRight size={16} /></a>
    </motion.div>
  </section>
);
